import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Flex,
    IconArrowLeftOutline,
    IconArrowRightOutline,
    TextButton,
    Spacer,
} from '@zillow/constellation';

import {
    StyledContainerMobile,
    StyledContainerDesktop,
    StyledFlex,
} from './StyledComponents';

const propTypes = {
    onBackClick: PropTypes.func,
    onNextClick: PropTypes.func,
    onCustomActionClick: PropTypes.func,
    backLabel: PropTypes.string,
    nextLabel: PropTypes.string,
    customActionLabel: PropTypes.string,
    isBackDisabled: PropTypes.bool,
    isNextDisabled: PropTypes.bool,
    isCustomActionDisabled: PropTypes.bool,
    hideBackButton: PropTypes.bool,
    hideNextButton: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    onBackClick: null,
    onNextClick: null,
    onCustomActionClick: null,
    backLabel: 'Back',
    nextLabel: 'Next',
    customActionLabel: '',
    isBackDisabled: false,
    isNextDisabled: false,
    isCustomActionDisabled: false,
    hideBackButton: false,
    hideNextButton: false,
    className: '',
};

const WizardActionFooter = ({
    onBackClick,
    onNextClick,
    onCustomActionClick,
    backLabel,
    nextLabel,
    customActionLabel,
    isBackDisabled,
    isNextDisabled,
    isCustomActionDisabled,
    hideBackButton,
    hideNextButton,
    className,
}) => {
    const renderBackButton = () => (
        <Button
            buttonType="secondary"
            onClick={onBackClick}
            disabled={isBackDisabled}
        >
            <IconArrowLeftOutline />
            &nbsp;
            {backLabel}
        </Button>
    );

    const renderNextButton = () => (
        <Button
            className="nextButton"
            buttonType="primary"
            onClick={onNextClick}
            disabled={isNextDisabled}
        >
            {nextLabel}
            &nbsp;
            <IconArrowRightOutline />
        </Button>
    );

    const renderCustomButton = () => (
        <TextButton
            onClick={onCustomActionClick}
            disabled={isCustomActionDisabled}
        >
            {customActionLabel}
        </TextButton>
    );

    return (
        <>
            <StyledContainerMobile className={className}>
                {customActionLabel && (
                    <Spacer paddingBottom="md">
                        <Flex display="flex" justifyContent="center">
                            {renderCustomButton()}
                        </Flex>
                    </Spacer>
                )}
                <StyledFlex
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mediaQuery={{ md: { flexDirection: 'row' } }}
                >
                    {!hideBackButton && renderBackButton()}
                    {!hideNextButton && renderNextButton()}
                </StyledFlex>
            </StyledContainerMobile>
            <StyledContainerDesktop className={className}>
                <Flex display="flex" flexDirection="column" alignItems="center">
                    {customActionLabel && (
                        <Spacer>
                            {renderCustomButton()}
                        </Spacer>
                    )}
                </Flex>
                <Flex display="flex" flexDirection="row" alignItems="center">
                    <Flex flex="1">
                        {!hideBackButton && renderBackButton()}
                    </Flex>
                    {!hideNextButton && renderNextButton()}
                </Flex>
            </StyledContainerDesktop>
        </>
    );
};

WizardActionFooter.propTypes = propTypes;
WizardActionFooter.defaultProps = defaultProps;

export default WizardActionFooter;
